<template>
  <div id="base" class="home-container" v-title title="首页">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="header-content">
        <img id="u52_img" class="background-img"  src="@/images/shenqin/u52.png" alt="Logo"/>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="main-content">
      <div class="welcome-section">
        <div class="welcome-card">
          <div class="welcome-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2L2 7v10l10 5 10-5V7L12 2zm0 2.5l7.36 4.68L12 15.5 4.64 9.18L12 4.5zM4 9v9.82l8 4v-9.82L4 9zm16 0l-8 4.82v9.82l8-4V9z"/>
            </svg>
          </div>
          <h1 class="welcome-title">欢迎使用机构信息填报系统</h1>
          <p class="welcome-subtitle">请根据提示完成相关信息的填写与提交</p>
        </div>
      </div>

      <!-- 操作卡片 -->
      <div class="action-section">
        <div class="action-grid">
          <!-- 开户信息填报卡片 -->
          <div 
            class="action-card card-primary" 
            :class="{disabled: orgInfoOnOff != 1}"
            @click="orgInfoOnOff == 1 ? kaihu() : null"
          >
            <div class="card-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
              </svg>
            </div>
            <div class="card-content">
              <h3>填报开户信息</h3>
              <p>填写机构基本信息、法人信息及营业执照等</p>
            </div>
            <div class="card-status" v-if="orgInfoOnOff == 1">
              <span class="status-badge active">可填报</span>
            </div>
            <div class="card-status" v-else>
              <span class="status-badge inactive">已结束</span>
            </div>
            <div class="card-action" v-if="orgInfoOnOff == 1">
              立即填报 →
            </div>
          </div>

          <!-- 填报已结束提示 -->
          <div 
            class="action-card card-secondary" 
            v-if="orgInfoOnOff != 1"
            @click="heib"
          >
            <div class="card-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
              </svg>
            </div>
            <div class="card-content">
              <h3>填报已结束</h3>
              <p>当前填报周期已截止，请等待下次开放</p>
            </div>
            <div class="card-action">
              查看详情 →
            </div>
          </div>

          <!-- 其他功能卡片（可根据需要添加） -->
          <div class="action-card card-info" @click="jig">
            <div class="card-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
              </svg>
            </div>
            <div class="card-content">
              <h3>信息查询</h3>
              <p>查询已提交的机构信息和审核状态</p>
            </div>
            <div class="card-action">
              暂未开通 →
            </div>
          </div>
        </div>
      </div>

      <!-- 快速指引 -->
      <div class="guidance-section">
        <div class="section-header">
          <h2>填报指引</h2>
          <p>按照以下步骤完成信息填报</p>
        </div>
        <div class="steps">
          <div class="step-item">
            <div class="step-number">1</div>
            <div class="step-content">
              <h4>准备材料</h4>
              <p>准备好营业执照、法人身份证等资料</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-number">2</div>
            <div class="step-content">
              <h4>填写信息</h4>
              <p>准确填写机构基本信息和法人信息</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-number">3</div>
            <div class="step-content">
              <h4>上传资料</h4>
              <p>按要求上传相关证明文件</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-number">4</div>
            <div class="step-content">
              <h4>提交审核</h4>
              <p>确认无误后提交信息等待审核</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <div id="u58" class="footer">
      <div class="footer-content">
        <div class="footer-links">
          <div class="link-item">
            <strong>主办：</strong>河北省体育局
          </div>
          <div class="link-item">
            <strong>地址：</strong>河北省石家庄市中山东路372号
          </div>
          <div class="link-item">
            <strong>邮编：</strong>050011
          </div>
          <div class="link-item">
            <strong>邮箱：</strong>hebeitiyuju@163.com
          </div>
          <div class="link-item">
            <strong>运维电话：</strong>0311-85266259
          </div>
          <div class="link-item">
            <strong>技术支持：</strong>13180076188
          </div>
        </div>
        <div class="footer-copyright">
          <p>河北省体育局版权所有 © 2025</p>
          <p class="icp-info">
            冀ICP备：2022017224号 | 冀公网安备：13010202002305号
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ElMessage} from "element-plus";
import {
    getConfigByKey
} from "@/requst/api";

export default {
  name: 'RuKou',
  data() {
    return {
        orgInfoOnOff:1
    }
  },
  created() {
      this.getOrgInfoOnOff();
  },
  methods: {
    kaihu(){
        localStorage.clear();
        localStorage.setItem('type', 1)
        localStorage.setItem('yyzz',2)
        this.$router.push('kaihu')
    },
    heib(){
      ElMessage.error('该版块正在建设中')
    },
    jig(){
      ElMessage.error('信息暂未开放查询权限。')
		//this.$router.push('chaxun')
    },
    getOrgInfoOnOff(){
        getConfigByKey().then(response => {
          this.orgInfoOnOff = response.msg;
      });
    }
  }
}
</script>

<style scoped>
.home-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
}

/* 顶部导航栏样式 */
.header {
  background: white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 10;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto; 
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-background {
  flex: 1;
  display: flex;
  justify-content: center;
}

.background-img {
  width: 100%; 
  height: auto;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  overflow: hidden; /* 确保图片内容不会超出圆角边界 */
}

.logo {
  height: 50px;
  width: auto;
}

/* 主内容区样式 */
.main-content {
  flex: 1;
  max-width: 1200px;
  margin: 0 auto; 
  width: 100%;
}

/* 欢迎区域 */
.welcome-section {
  margin: 30px 0 50px;
}

.welcome-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.welcome-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  color: white;
}

.welcome-icon svg {
  width: 40px;
  height: 40px;
}

.welcome-title {
  font-size: 32px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.welcome-subtitle {
  font-size: 18px;
  color: #666;
  line-height: 1.6;
}

/* 操作区域 */
.action-section {
  margin: 40px 0;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.section-header h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
}

.section-header p {
  color: #666;
  font-size: 16px;
}

.action-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-bottom: 50px;
}

.action-card {
  background: white;
  border-radius: 16px;
  padding: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border: 2px solid transparent;
}

.action-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.action-card.disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.action-card.disabled:hover {
  transform: none;
  box-shadow: none;
}

.card-primary {
  border-color: #667eea;
}

.card-primary:hover {
  border-color: #764ba2;
}

.card-secondary {
  border-color: #ff6b6b;
}

.card-info {
  border-color: #4ecdc4;
}

.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.card-primary .card-icon {
  background: linear-gradient(135deg, #667eea20 0%, #764ba220 100%);
  color: #667eea;
}

.card-secondary .card-icon {
  background: linear-gradient(135deg, #ff6b6b20 0%, #ff8e8e20 100%);
  color: #ff6b6b;
}

.card-info .card-icon {
  background: linear-gradient(135deg, #4ecdc420 0%, #44a08d20 100%);
  color: #4ecdc4;
}

.card-icon svg {
  width: 28px;
  height: 28px;
}

.card-content h3 {
  font-size: 22px;
  color: #333;
  margin-bottom: 10px;
}

.card-content p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.card-status {
  position: absolute;
  top: 30px;
  right: 30px;
}

.status-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.active {
  background: #10b98120;
  color: #10b981;
}

.status-badge.inactive {
  background: #ef444420;
  color: #ef4444;
}

.card-action {
  color: #667eea;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  transition: all 0.3s ease;
}

.card-primary:hover .card-action {
  color: #764ba2;
  transform: translateX(5px);
}

/* 指引区域 */
.guidance-section {
  background: white;
  border-radius: 20px;
  padding: 40px;
  margin-top: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  margin-top: 30px;
}

.step-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.step-number {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 18px;
  flex-shrink: 0;
}

.step-content h4 {
  font-size: 18px;
  color: #333;
  margin-bottom: 8px;
}

.step-content p {
  color: #666;
  line-height: 1.6;
}

/* 底部样式 */
.footer {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #fff;
  padding: 40px 0 20px;
  margin-top: 60px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 30px;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.link-item {
  color: #aaa;
  line-height: 1.8;
}

.link-item strong {
  color: #ccc;
}

.footer-copyright {
  text-align: center;
  color: #888;
  font-size: 14px;
}

.footer-copyright p {
  margin: 5px 0;
}

.icp-info {
  font-size: 13px;
  color: #666;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  
  .welcome-title {
    font-size: 24px;
  }
  
  .welcome-subtitle {
    font-size: 16px;
  }
  
  .action-grid {
    grid-template-columns: 1fr;
  }
  
  .steps {
    grid-template-columns: 1fr;
  }
  
  .main-content {
    padding: 20px;
  }
  
  .welcome-card,
  .action-card,
  .guidance-section {
    padding: 25px;
  }
}

@media (max-width: 480px) {
  .welcome-icon {
    width: 60px;
    height: 60px;
  }
  
  .welcome-icon svg {
    width: 30px;
    height: 30px;
  }
  
  .card-icon {
    width: 50px;
    height: 50px;
  }
  
  .card-icon svg {
    width: 24px;
    height: 24px;
  }
  
  .footer-links {
    grid-template-columns: 1fr;
  }
}
</style> 